import React from 'react';
import { NavItemDef } from '../navItems';

export const LEXID_NAV_ITEMS: NavItemDef[] = [
  {
    key: 'organization.settings',
    label: 'common.navItems.lexid.organizationSettings',
    path: 'settings',
    permissions: ['getOrg'],
  },
  {
    key: 'manage.solutions',
    label: 'common.navItems.lexid.manageSolutions',
    path: 'manage-solutions',
    permissions: ['editOrgSolution'],
    nonRoot: true,
  },
  {
    key: 'organization.users',
    label: 'common.navItems.lexid.manageUsers',
    path: 'users',
    permissions: ['listUsers'],
    nonRoot: true,
  },
  {
    key: 'organization.user_imports',
    label: 'common.navItems.lexid.userImports',
    path: 'user-imports',
    permissions: ['listJobsImportUsers'],
    nonRoot: true,
  },
  {
    key: 'organization.roles',
    label: 'common.navItems.lexid.manageRoles',
    path: 'roles',
    permissions: ['listRoles'],
    nonRoot: true,
  },
  {
    key: 'organization.groups',
    label: 'common.navItems.lexid.manageGroups',
    path: 'groups',
    permissions: ['listGroups'],
    nonRoot: true,
  },
  {
    key: 'organization.riskPoolSharing',
    label: 'common.navItems.lexid.riskPoolSharing',
    path: 'risk-pool-sharing',
    permissions: ['addRelatedOrg'],
    nonRoot: true,
    requiresRiskPool: true,
  },
  {
    key: 'organizations',
    label: 'common.navItems.lexid.manageOrganizations',
    path: 'organizations',
    appPermissions: ['listOrgs'],
    sameOrg: true,
  },
];
